module.exports = __webpack_public_path__ + "static/logo_thaifood-22966af7b9790cee7afb70aefde7ce0e.svg";